<div class="not-sidenav-container" *ngIf="!isSideNav">
    <div *ngIf="hasMatMenu">
        <div *ngIf="!isAdmin && !isSubMenuFullScreen" class="nav {{ logoPosition }} {{ hasLogo }} {{colorOfNavBar }}"
            id="navbar" #navbar>
            <div *ngIf="logoPosition === headerConfig.PositionL || !hasLogo" class="desktop-menu">
                <div *ngFor="let navigationItem of navigationMenu" class="{{ navigationItem.id }} nav-bar-item">

                    <ng-container *ngIf="navigationItem.staticSubMenus?.length! > 0; else noSubmenu">
                        <button mat-button [matMenuTriggerFor]="menu" (click)="routingMenuItem(navigationItem)">
                            {{ navigationItem.translationKey }}
                        </button>

                        <mat-menu #menu="matMenu" [overlapTrigger]="false" yPosition="below" [ngStyle]="{
                                            'color': '#e8fcfd',
                                            'text-transform': 'uppercase',
                                            'font-weight': '400',
                                            'font-size': '18px',
                                            'padding': '8px',
                                            'font-family': 'Quicksand'
                                          }">
                            <button mat-menu-item *ngFor="let submenu of navigationItem.staticSubMenus"
                                [routerLink]="submenu.id">
                                <span [ngStyle]="{'font-size':'14px','text-transform':'capitalize'}">{{
                                    submenu.translationKey}}</span>
                            </button>
                        </mat-menu>
                    </ng-container>

                    <ng-template #noSubmenu>
                        <button mat-button (click)="routingMenuItem(navigationItem)">
                            {{ navigationItem.translationKey }}
                        </button>
                    </ng-template>
                </div>
            </div>
            <div *ngIf="logoPosition === headerConfig.PositionM && hasLogo" class="desktop-menu left">
                <div *ngFor="let navigationItem of leftNavigationMenu" class="{{ navigationItem.id }} nav-bar-item">
                    <a *ngIf="!navigationItem.isHidden" routerLink="{{ navigationItem.id }}"> {{
                        navigationItem.translationKey }} </a>
                </div>
            </div>

            <div *ngIf="logoPosition === headerConfig.PositionM && hasLogo" class="image nav-bar-item-middle">
                <a *ngIf="!whichLogoDisplays" href routerLink="/"><img #logo id="logo" class="logo" /></a>
                <a *ngIf="whichLogoDisplays" href routerLink="/"><img #logo id="logo" class="resizedlogo" /></a>
            </div>

            <div *ngIf="logoPosition === headerConfig.PositionM && hasLogo" class="desktop-menu right">
                <div *ngFor="let navigationItem of rightNavigationMenu" class="{{ navigationItem.id }} nav-bar-item">
                    <a *ngIf="!navigationItem.externalLink && !navigationItem.isHidden"
                        routerLink="/{{ navigationItem.id }}" class="events nav-bar-item">
                        {{ navigationItem.translationKey }}
                        <div class="content">
                            <a *ngFor="let submenu of navigationItem.staticSubMenus" class="submenu">{{
                                submenu.translationKey }}</a>
                        </div>
                    </a>
                    <a (click)="settingUpLinkToGoogleAnalytics(navigationItem.externalLink)"
                        class="events nav-bar-item-issue"
                        *ngIf="navigationItem.externalLink && !navigationItem.isHidden" target="_blank"
                        href="{{ navigationItem.externalLink }}">
                        {{ navigationItem.translationKey }}
                    </a>
                </div>
            </div>
            <app-languagemodule *ngIf="languages.length >= 4"></app-languagemodule>
        </div>

        <div *ngIf="isAdmin && !isSubMenuFullScreen" class="nav {{colorOfNavBar }}" id="navbar" #navbar>
            <div class="home-icon">
                <mat-icon [ngStyle]="{'color':'white','cursor':'pointer'}" [routerLink]="adminHomeUrl"
                    class="logo">home</mat-icon>
            </div>
            <div class="desktop-menu">
                <div *ngFor="let navigationItem of navigationMenu" class="{{ navigationItem.id }} nav-bar-item">
                    <button
                        [ngStyle]="{'color':'white','text-transform':'uppercase','font-weight':'400','font-size':'18px','padding':'8px','font-family': 'Quicksand'}"
                        *ngIf="!navigationItem.externalLink && !navigationItem.isHidden"
                        routerLink="{{ navigationItem.id }}" mat-button
                        [matMenuTriggerFor]="navigationItem.hasDynamicSubMenu ? aboveMenu : null">
                        {{ navigationItem.translationKey }}
                    </button>
                    <button
                        [ngStyle]="{'font-family': 'Quicksand','color':'white','text-transform':'uppercase','font-weight':'400','font-size':'18px','padding':'8px'}"
                        *ngIf="navigationItem.externalLink && !navigationItem.isHidden" target="_blank"
                        routerLink="{{navigationItem.externalLink}}" mat-button
                        [matMenuTriggerFor]="navigationItem.hasDynamicSubMenu ? aboveMenu : null">
                        {{ navigationItem.translationKey }}
                    </button>
                    <mat-menu #aboveMenu="matMenu" yPosition="above">
                        <button
                            [ngStyle]="{'color':'white','text-transform':'uppercase','font-weight':'400','font-size':'18px','padding':'8px', 'font-family': 'Quicksand'}"
                            routerLink="{{submenu.id}}" *ngFor="let submenu of navigationItem.staticSubMenus"
                            mat-menu-item>
                            {{submenu.translationKey}}
                        </button>
                    </mat-menu>
                </div>
            </div>
            <div (click)="logOut()" class="placeholder">
                <mat-icon>assignment_return</mat-icon>
                <span>Kijelentkezés</span>
            </div>
            <div *ngIf="logoPosition === headerConfig.PositionM && hasLogo" class="desktop-menu left">
                <div *ngFor="let navigationItem of leftNavigationMenu" class="{{ navigationItem.id }} nav-bar-item">
                    <a *ngIf="!navigationItem.isHidden" routerLink="{{ navigationItem.id }}"> {{
                        navigationItem.translationKey }} </a>
                </div>
            </div>

            <div *ngIf="logoPosition === headerConfig.PositionM && hasLogo" class="image nav-bar-item-middle">
                <a *ngIf="!whichLogoDisplays" href routerLink="/"><img #logo id="logo" class="logo" /></a>
                <a *ngIf="whichLogoDisplays" href routerLink="/"><img #logo id="logo" class="resizedlogo" /></a>
            </div>

            <div *ngIf="logoPosition === headerConfig.PositionM && hasLogo" class="desktop-menu right">
                <div *ngFor="let navigationItem of rightNavigationMenu" class="{{ navigationItem.id }} nav-bar-item">
                    <a *ngIf="!navigationItem.externalLink && !navigationItem.isHidden"
                        routerLink="/{{ navigationItem.id }}" class="events nav-bar-item">
                        {{ navigationItem.translationKey }}
                        <div class="content">
                            <a *ngFor="let submenu of navigationItem.staticSubMenus" class="submenu">{{
                                submenu.translationKey }}</a>
                        </div>
                    </a>
                    <a (click)="settingUpLinkToGoogleAnalytics(navigationItem.externalLink)"
                        class="events nav-bar-item-issue"
                        *ngIf="navigationItem.externalLink && !navigationItem.isHidden" target="_blank"
                        href="{{ navigationItem.externalLink }}">
                        {{ navigationItem.translationKey }}
                    </a>
                </div>
            </div>
            <app-languagemodule *ngIf="languages.length >= 4"></app-languagemodule>
        </div>
    </div>

    <div *ngIf="!hasMatMenu" class="nav">
        <div class="desktop-menu">
            <div class="nav-bar-item" *ngFor="let navigation of navigationMenu">
                <button *ngIf="!navigation.externalLink" (click)="showSubMenu(navigation)">
                    {{ navigation.translationKey | uppercase }}
                </button>
                <a (click)="settingUpLinkToGoogleAnalytics(navigation.externalLink)" *ngIf="navigation.externalLink"
                    href="{{navigation.externalLink}}" target="_blank">{{
                    navigation.translationKey | uppercase }}</a>
            </div>
        </div>
    </div>
    <div class="submenu-container" *ngIf="showSubmenu">
        <div (mouseleave)="closeSubMenu()" class="submenu">
            <div (click)="closeSubMenu()" class="sub" *ngFor="let sub of submenu">
                <div *ngIf="sub.id!==''" [ngStyle]="{'display':'flex','width':'100%','align-items':'center'}">
                    <button class="sub-button">
                        <span>{{ sub.translationKey }}</span>
                    </button>
                    <mat-icon (click)="routeSubmenuIfItHasRouterLink(sub)">info</mat-icon>
                </div>
                <button *ngIf="sub.id === ''" class="sub-button">
                    <span>{{ sub.translationKey }}</span>
                </button>
                <div class="subsub-container" *ngFor="let subsub of sub.staticSubMenus">
                    <div class="subsub" *ngIf="sub.hasDynamicSubMenu">
                        <mat-icon *ngIf="!subsub.hasDynamicSubMenu">keyboard_arrow_right</mat-icon>
                        <button *ngIf="!subsub.hasDynamicSubMenu" routerLink="{{ subsub.id }}">
                            <span>{{subsub.translationKey}}</span>
                        </button>
                        <button *ngIf="subsub.hasDynamicSubMenu">
                            <span>{{subsub.translationKey}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="nav-mobile {{ hasLogo }} {{colorOfNavBar}}">
        <div class="button">
            <button mat-icon-button *ngIf="sidenav.mode === 'over'" (click)="sidenav.toggle()" onclick="this.blur()">
                <mat-icon *ngIf="!sidenav.opened"> menu </mat-icon>
            </button>
        </div>

        <div class="home-icon {{hasLogo}}">
            <img [ngStyle]="{'width':'28px'}" routerLink="/" src={{mobileLogoUrl}} class="logo" />
        </div>
        <div class="login-shopping-cart">
            <div *ngIf="!isLoggedIn" class="login-shopping-cart">
                <div class="login-icon">
                    <mat-icon (click)="openLogin()" *ngIf="hasLogin">account_circle </mat-icon>
                </div>
            </div>
            <pw-shoppingcart *ngIf="isShoppingCart"></pw-shoppingcart>
        </div>
    </div>

    <mat-sidenav-container>
        <mat-sidenav #sidenav="matSidenav">
            <div class="sidenav-content {{colorOfMobileSidenav}}">
                <div class="close-icon">
                    <span>{{nameOfTheSite}}</span>
                    <mat-icon (click)="sidenav.toggle()" (click)="closeSubmenus()" class="close" float="right"> close
                    </mat-icon>
                </div>
                <div *ngIf="hasMenuTitle" class="menu-title">
                    <span>{{ "company.name" | translate }}</span>
                </div>
                <div *ngFor="let navigationItem of navigationMenu; let i = index"
                    class="{{ navigationItem.id }} nav-bar-item">
                    <button
                        *ngIf="!navigationItem.externalLink && !navigationItem.staticSubMenus  && !navigationItem.isHidden"
                        routerLink="{{ navigationItem.id }}" (click)="sidenav.toggle();closeSubmenus()"
                        class="menu-button">
                        <span [ngStyle]="{'font-weight':'bold'}">{{ navigationItem.translationKey }}</span>
                    </button>
                    <div (click)="displaySubmenu(navigationItem.translationKey!)"
                        [ngStyle]="{'display':'flex','width':'98%','align-items':'center','justify-content':'space-between'}"
                        class="navigation-item"
                        *ngIf="!navigationItem.externalLink && navigationItem.staticSubMenus && !navigationItem.isHidden">
                        <button class="menu-button">
                            <span [ngStyle]="{'font-weight':'bold'}">{{ navigationItem.translationKey }}</span>
                        </button>
                        <mat-icon #icon id="{{ navigationItem.id }}"
                            class="fa fa-angle-down">keyboard_arrow_right</mat-icon>
                    </div>
                    <a (click)="settingUpLinkToGoogleAnalytics(navigationItem.externalLink)" class="menu"
                        *ngIf="navigationItem.externalLink && !navigationItem.isHidden" target="_blank"
                        href="{{ navigationItem.externalLink }}">
                        <span [ngStyle]="{'font-weight':'bold'}">{{ navigationItem.translationKey }}</span>
                    </a>
                    <div *ngIf="navigationItem.hasDynamicSubMenu">
                        <div *ngFor="let submenu of navigationItem.staticSubMenus" class="sub">
                            <div *ngIf="navigationItem.isStaticSubmenuVisible" class="content">
                                <a [ngStyle]="{'margin-left':'4px'}"
                                    *ngIf="!submenu.isHidden && !submenu.hasDynamicSubMenu"
                                    routerLink="{{ submenu.id }}" class="submenu"
                                    (click)="sidenav.toggle();closeSubmenus()">{{ submenu.translationKey }}</a>
                                <div [ngStyle]="{'display':'flex','width':'250px','align-items':'center','justify-content':'space-between'}"
                                    *ngIf="submenu.hasDynamicSubMenu">
                                    <a (click)="displaySubSubmenu(submenu.translationKey!)"
                                        [ngStyle]="{'font-size':'14px','margin-left':'4px','font-weight':'bold'}"
                                        class="submenu">{{ submenu.translationKey }}</a>
                                </div>
                                <mat-icon *ngIf="submenu.id!==''"
                                    (click)="routeSubmenuIfItHasRouterLink(submenu);sidenav.toggle();closeSubmenus()">info</mat-icon>
                                <mat-icon *ngIf="submenu.hasDynamicSubMenu" #icon id="{{ navigationItem.id }}"
                                    class="fa fa-angle-down">keyboard_arrow_right</mat-icon>
                            </div>
                            <div *ngIf="submenu.hasDynamicSubMenu">
                                <div>
                                    <div *ngFor="let subsub of submenu.staticSubMenus">
                                        <div *ngIf="!subsub.hasDynamicSubMenu">
                                            <div [ngStyle]="{'display':'flex','width':'250px','margin-left':'32px'}"
                                                *ngIf="submenu.isStaticSubmenuVisible">
                                                <a [ngStyle]="{'margin-left':'4px','padding':'8px','font-size':'16px'}"
                                                    *ngIf="!subsub.isHidden" routerLink="{{ subsub.id }}"
                                                    class="submenu" (click)="sidenav.toggle();closeSubmenus()">{{
                                                    subsub.translationKey }}</a>
                                            </div>
                                        </div>
                                        <div *ngIf="subsub.hasDynamicSubMenu">
                                            <a [ngStyle]="{'margin-left':'4px'}" *ngIf="!subsub.isHidden"
                                                class="submenu">{{ subsub.translationKey }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="login-menu" *ngIf="isLoggedIn">
                    <div class="menu-title">
                        <span>FIÓKOM</span>
                    </div>
                    <button *ngIf="!isAdmin" (click)="sidenav.toggle();getPersonalData()" class="menu-button">
                        <span>{{ 'header.personalDatas' | translate }}</span>
                    </button>
                    <button *ngIf="!isAdmin" (click)="sidenav.toggle();getMyOrders() " class="menu-button">
                        <span>{{ 'header.myOrders' | translate }}</span>
                    </button>
                    <button (click)="sidenav.toggle();logOut()" class="menu-button">
                        <span>{{ 'header.logOut' | translate }}</span>
                    </button>
                </div>
            </div>
        </mat-sidenav>
    </mat-sidenav-container>

    <div *ngIf="isSubMenuFullScreen" class="nav {{ logoPosition }} {{ hasLogo }} {{colorOfNavBar }}" id="navbar"
        #navbar>
        <div *ngIf="logoPosition === headerConfig.PositionL || !hasLogo" class="desktop-menu">
            <div *ngFor="let navigationItem of navigationMenu" class="{{ navigationItem.id }} nav-bar-item">
                <button *ngIf="!navigationItem.externalLink && !navigationItem.isHidden"
                    routerLink="{{ navigationItem.id }}">
                    {{ navigationItem.translationKey }}
                </button>
                <button *ngIf="navigationItem.externalLink && !navigationItem.isHidden" target="_blank"
                    routerLink="{{navigationItem.externalLink}}">
                    {{ navigationItem.translationKey }}
                </button>
                <div class="full-screen-submenu">
                    <button routerLink="{{submenu.id}}" *ngFor="let submenu of navigationItem.staticSubMenus">
                        {{submenu.translationKey}}
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="logoPosition === headerConfig.PositionM && hasLogo" class="desktop-menu left">
            <div *ngFor="let navigationItem of leftNavigationMenu" class="{{ navigationItem.id }} nav-bar-item">
                <a *ngIf="!navigationItem.isHidden" routerLink="{{ navigationItem.id }}"> {{
                    navigationItem.translationKey }} </a>
            </div>
        </div>

        <div *ngIf="logoPosition === headerConfig.PositionM && hasLogo" class="image nav-bar-item-middle">
            <a *ngIf="!whichLogoDisplays" href routerLink="/"><img #logo id="logo" class="logo" /></a>
            <a *ngIf="whichLogoDisplays" href routerLink="/"><img #logo id="logo" class="resizedlogo" /></a>
        </div>

        <div *ngIf="logoPosition === headerConfig.PositionM && hasLogo" class="desktop-menu right">
            <div *ngFor="let navigationItem of rightNavigationMenu" class="{{ navigationItem.id }} nav-bar-item">
                <a *ngIf="!navigationItem.externalLink && !navigationItem.isHidden"
                    routerLink="/{{ navigationItem.id }}" class="events nav-bar-item">
                    {{ navigationItem.translationKey }}
                    <div class="content">
                        <a *ngFor="let submenu of navigationItem.staticSubMenus" class="submenu">{{
                            submenu.translationKey }}</a>
                    </div>
                </a>
                <a (click)="settingUpLinkToGoogleAnalytics(navigationItem.externalLink)"
                    class="events nav-bar-item-issue" *ngIf="navigationItem.externalLink && !navigationItem.isHidden"
                    target="_blank" href="{{ navigationItem.externalLink }}">
                    {{ navigationItem.translationKey }}
                </a>
            </div>
        </div>
        <app-languagemodule *ngIf="languages.length >= 4"></app-languagemodule>
    </div>
</div>

<app-navigationregenero [isRowView]="isRowView" [navigationMenu]="navigationMenu"
    *ngIf="isSideNav"></app-navigationregenero>